import { LoggedOut } from '@fiverr-private/header/';

export default LoggedOut;
